export default "__VITE_ASSET__2de90f44__"